<div>
    <ng-container *ngIf="!orders; else orderList">
        <div class="text-center">
            <app-loader></app-loader>
        </div>
    </ng-container>
    <ng-template #orderList>
        <ng-container *ngIf="orders.length === 0">
            <div class="py-4 text-center">
                {{ "No orders found" | translate }}
            </div>
        </ng-container>
        <div class="table-responsive">
            <table class="table mw-500 sales-table" *ngIf="orders.length > 0">
                <thead>
                    <tr>
                        <th>{{ "Date" | translate }}</th>
                        <th>{{ "Order number" | translate }}</th>
                        <th>{{ "Client" | translate }}</th>
                        <th>{{ "Order status" | translate }}</th>
                        <th>{{ "Price" | translate }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let order of orders">
                        <td [attr.data-label]="'Date' | translate">
                            <span class="sales-table-value">{{ order.createdAt | date: "dd.MM.yyyy" }}</span>
                        </td>
                        <td class="sales-table-reference" [attr.data-label]="'Order number' | translate">
                            <span class="sales-table-value">{{ order.ref }}</span>
                        </td>
                        <td [attr.data-label]="'Client' | translate">
                            <span class="sales-table-value">{{ order.customer.fullname }}</span>
                        </td>
                        <td class="order-status" [class]="order.statusColor" [attr.data-label]="'Order status' | translate">
                            <span class="sales-table-value" [innerHTML]="order.statusFormatted | translate"></span>
                        </td>
                        <td [attr.data-label]="'Price' | translate">
                            <span class="sales-table-value"><app-price [price]="order.totalPriceObject"></app-price></span>
                        </td>
                        <td class="text-right sales-table-actions">
                            <a class="fs-5" [routerLink]="['/profile/orders', order.ref]">
                                <i class="bi bi-eye"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-template>
</div>
